import React from "react"
import ToolTip from "react-portal-tooltip"
import autobind from "class-autobind"
import { ELanguage, IPrivacyAgreementDocument } from "../../models"
import { FontIcon } from "material-ui"
import { greenA700, grey500 } from "material-ui/styles/colors"
import AuthenticationStore from "../../stores/AuthenticationStore"
interface IProps {
    keyStr: string
    latestAgreement: IPrivacyAgreementDocument
}
interface IState {
    open: boolean
}

export default class AcceptedIcon extends React.Component<IProps, IState>  {
    constructor(props) {
        super(props)
        this.state = {
            open: false
        }
        autobind(this)
    }

    render() {
        let agreement = this.props.latestAgreement.Agreements.find(i => i.Language === AuthenticationStore.getLoggedInUserLanguage())
        if (!agreement) {
            agreement = this.props.latestAgreement.Agreements.find(i => i.Language === ELanguage.English)
        }
        return (
            <div>
                <ToolTip
                    style={{
                        style: {
                            maxHeight: 700,
                            width: 500,
                            overflowY: "auto",
                            padding: 20,
                        },
                        arrowStyle: {
                            color: grey500,
                            borderColor: true
                        }
                    }}
                    active={this.state.open}
                    position="right"
                    arrow="center"
                    parent={"#" + this.props.keyStr}
                    key={this.props.keyStr}
                    group={this.props.keyStr}
                    tooltipTimeout={50}
                >
                    <div id={`AgreementDetail_${this.props.keyStr}`} />
                </ToolTip>
                <FontIcon
                    id={this.props.keyStr}
                    className="fa fa-check-circle-o"
                    color={greenA700}
                    style={{ fontSize: 16, marginTop: 2, marginRight: 5 }}
                    onMouseOver={() =>
                        this.setState({ open: true }, () =>
                            document.getElementById(`AgreementDetail_${this.props.keyStr}`).innerHTML = agreement && agreement.AgreementText
                        )
                    }
                    onMouseOut={() => this.setState({ open: false })}
                />
            </div>
        )
    }
}
